import { TransportMean, TransportMeanIconNameMap } from "../../../../interfaces/register-user.response"

export const rawTransportMeans = [
  { label: 'Andando', iconName: TransportMeanIconNameMap.walk, eco: true },
  { label: 'BiciMad', iconName: TransportMeanIconNameMap.bike, eco: true },
  { label: 'Bus EMT', iconName: TransportMeanIconNameMap['bus-emt'], eco: true },
  { label: 'Bus Interurbano', iconName: TransportMeanIconNameMap['bus-interurbano'], eco: false },
  { label: 'Metro', iconName: TransportMeanIconNameMap.metro, eco: false },
  { label: 'Metro Ligero', iconName: TransportMeanIconNameMap['metro-ligero'], eco: false },
  { label: 'Cercanías', iconName: TransportMeanIconNameMap.cercanias, eco: false },
]

export const initialTransportMeans: TransportMean = 
  { 
    id: 0,
    label: "Andando",
    value: "andando",
    iconName: TransportMeanIconNameMap.walk,
    eco: true
  }
